import { Button } from "@mui/material";

function DecrementDonation({ isShow, decDonation }: { isShow: boolean, decDonation: () => void }) {
    return (
        isShow ?
            <Button className="add-btn p-0 color-white" color="error" onClick={decDonation}>
                <i className="ri-subtract-line"></i>
            </Button>
            :
            null
    )
}

export default DecrementDonation;